// Import all health & safety icon categories
import {
  emergencyEquipmentIcons,
  evacuationSafetyPointsIcons,
  hazardsRiskAreasIcons,
  accessEntryIcons,
  documentationTrainingIcons,
  resourcesInfrastructureIcons,
  roadsIcons
} from '../containers/Pages/PropertyMap/Icons/HealthSafetyIcons';

/**
 * Health & Safety Icon Map
 * Maps icon keys to their generator functions
 * All icons now use state-based colors and uniform sizing (226x336 viewBox, scale 2.2)
 */
export const healthSafetyIconMap = {
  // Emergency Equipment
  "emergency_equipment__fire_extinguisher": emergencyEquipmentIcons.fire_extinguisher,
  "emergency_equipment__fire_blanket": emergencyEquipmentIcons.fire_blanket,
  "emergency_equipment__first_aid_kit": emergencyEquipmentIcons.first_aid_kit,
  "emergency_equipment__eyewash_station": emergencyEquipmentIcons.eyewash_station,
  "emergency_equipment__emergency_shower": emergencyEquipmentIcons.emergency_shower,
  "emergency_equipment__spill_kit": emergencyEquipmentIcons.spill_kit,
  "emergency_equipment__defibrillator_aed": emergencyEquipmentIcons.defibrillator_aed,
  "emergency_equipment__epi_pens": emergencyEquipmentIcons.epi_pens,
  "emergency_equipment__pumper": emergencyEquipmentIcons.pumper,
  "emergency_equipment__tanker": emergencyEquipmentIcons.tanker,

  // Evacuation & Safety Points
  "evacuation_safety_points__emergency_exit": evacuationSafetyPointsIcons.emergency_exit,
  "evacuation_safety_points__emergency_shelter": evacuationSafetyPointsIcons.emergency_shelter,
  "evacuation_safety_points__evacuation_point_assembly_area": evacuationSafetyPointsIcons.evacuation_point_assembly_area,
  "evacuation_safety_points__muster_point": evacuationSafetyPointsIcons.muster_point,

  // Hazards & Risk Areas
  "hazards_risk_areas__chemical_storage": hazardsRiskAreasIcons.chemical_storage,
  "hazards_risk_areas__fuel_storage": hazardsRiskAreasIcons.fuel_storage,
  "hazards_risk_areas__machinery_zone": hazardsRiskAreasIcons.machinery_zone,
  "hazards_risk_areas__overhead_powerlines": hazardsRiskAreasIcons.overhead_powerlines,
  "hazards_risk_areas__pesticide_herbicide_area": hazardsRiskAreasIcons.pesticide_herbicide_area,
  "hazards_risk_areas__water_body_dams": hazardsRiskAreasIcons.water_body_dams,
  "hazards_risk_areas__confined_space": hazardsRiskAreasIcons.confined_space,
  "hazards_risk_areas__fire_risk_zones": hazardsRiskAreasIcons.fire_risk_zones,
  "hazards_risk_areas__bee_and_pollination_zones": hazardsRiskAreasIcons.bee_and_pollination_zones,
  "hazards_risk_areas__biosecurity_checkpoints": hazardsRiskAreasIcons.biosecurity_checkpoints,
  "hazards_risk_areas__high_traffic_zone": hazardsRiskAreasIcons.high_traffic_zone,
  "hazards_risk_areas__poisonous_animal_zones": hazardsRiskAreasIcons.poisonous_animal_zones,
  "hazards_risk_areas__slippery_or_uneven_ground": hazardsRiskAreasIcons.slippery_or_uneven_ground,
  "hazards_risk_areas__stockpile_zones": hazardsRiskAreasIcons.stockpile_zones,

  // Access & Entry
  "access_entry__access_point_gate": accessEntryIcons.access_point_gate,
  "access_entry__entry_point": accessEntryIcons.entry_point,
  "access_entry__loading_bay": accessEntryIcons.loading_bay,
  "access_entry__no_go_zone": accessEntryIcons.no_go_zone,
  "access_entry__visitor_check_in_point": accessEntryIcons.visitor_check_in_point,

  // Documentation & Training
  "documentation_training__induction": documentationTrainingIcons.induction,
  "documentation_training__job_safety_analysis": documentationTrainingIcons.job_safety_analysis,
  "documentation_training__job_specific_training": documentationTrainingIcons.job_specific_training,
  "documentation_training__lock_out_tag_out": documentationTrainingIcons.lock_out_tag_out,
  "documentation_training__permit_to_work": documentationTrainingIcons.permit_to_work,
  "documentation_training__policy": documentationTrainingIcons.policy,
  "documentation_training__procedure": documentationTrainingIcons.procedure,
  "documentation_training__risk_assessment": documentationTrainingIcons.risk_assessment,
  "documentation_training__safe_operating_procedures": documentationTrainingIcons.safe_operating_procedures,
  "documentation_training__safety_data_sheet_sds_location": documentationTrainingIcons.safety_data_sheet_sds_location,

  // Resources & Infrastructure
  "resources_infrastructure__electricity_isolation_point": resourcesInfrastructureIcons.electricity_isolation_point,
  "resources_infrastructure__emergency_contact_board": resourcesInfrastructureIcons.emergency_contact_board,
  "resources_infrastructure__emergency_response_plans": resourcesInfrastructureIcons.emergency_response_plans,
  "resources_infrastructure__fuel_access": resourcesInfrastructureIcons.fuel_access,
  "resources_infrastructure__hydrants": resourcesInfrastructureIcons.hydrants,
  "resources_infrastructure__signage_general_safety_signs": resourcesInfrastructureIcons.signage_general_safety_signs,
  "resources_infrastructure__water_access_tank": resourcesInfrastructureIcons.water_access_tank,

  // Roads
  "roads__roadways": roadsIcons.roadways,
  "roads__speed_limits": roadsIcons.speed_limits,
  "roads__traffic_management_plans": roadsIcons.traffic_management_plans
};
